import { render, staticRenderFns } from "./SlideOverviewSchwedt.vue?vue&type=template&id=3469281e&scoped=true"
import script from "./SlideOverviewSchwedt.vue?vue&type=script&lang=js"
export * from "./SlideOverviewSchwedt.vue?vue&type=script&lang=js"
import style0 from "./SlideOverviewSchwedt.vue?vue&type=style&index=0&id=3469281e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3469281e",
  null
  
)

export default component.exports